import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { utils } from '../../utils';
import { CustomField, CustomFieldModel } from '../../types/customField';
import { EndpointResponse } from '../../types/endpoints';
import type { ApiQueryParams } from '../../types/apiQuery';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit'> & {
  model: CustomFieldModel;
};

type Response = CustomField[];

const validate = (model: CustomFieldModel) => {
  if (!model) {
    throw new Error('`model` is required');
  }
};

export const getCustomFields = async (
  scope: RequestScope,
  { model, limit = 1000 }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(model);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`${model}/fields?limit=${limit}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
